/**
 * @summary Main JS entry point.
 */

import './public-path';
import './font-load';
import './google-analytics';
import './logo';
import './primary-menu';
import './svg-polyfill';

if ( process.env.NODE_ENV !== 'production' ) {
	import( /* webpackChunkName: "preactDevtools" */ 'preact/devtools' );
}

Array.from( document.querySelectorAll( '.js-inview-list[data-selector]' ) )
	.forEach( list => {
		const selector = list.getAttribute( 'data-selector' );
		const items = list.querySelectorAll( selector );
		if ( items.length > 0 ) {
			import( /* webpackChunkName: "inView" */ './in-view' )
				.then( module => {
					new module.default( Array.from( items ) );
				});
		}
	});

if ( 'wc_data' in window ) {
	Array.from( document.querySelectorAll( '.product-addon--file_upload label' ) )
		.filter( label => !! label.control || !! label.getAttribute( 'for' ) )
		.forEach( label => {
			import( /* webpackChunkName: "fileUpload" */ './file-upload' )
				.then( module => {
					module.default( label );
				});
		});

	// Special description positioning
	const selector = '.product-addon--file_upload > .product-addon__extra';
	const extraEle = document.querySelector( selector );
	if ( extraEle ) {
		import( /* webpackChunkName: "fileUpload" */ './file-upload-description' )
			.then( module => module.default( extraEle ) );
	}
}

const featuredProducts = document.getElementById( 'js-featured-products' );
if ( featuredProducts ) {
	import( /* webpackChunkName: "featuredProducts" */ './featured-products' )
		.then( module => module.default( featuredProducts ) );
}

const cartForm = document.querySelector( 'form.woocommerce-cart-form' );
if ( cartForm ) {
	import( /* webpackChunkName: "cartAutoUpdate" */ './cart-auto-update' )
		.then( module => module.default( cartForm ) );
}



// WEBPACK FOOTER //
// ./src/js/index.js